import type { AddonT, BillingDetailsT } from "../../../../../../models/models";

/**
 * Checks whether the PayPal button should be shown based on the payment methods.
 *
 * @param isSubscription - Indicates if the purchase is a subscription.
 * @param subscriptionPaymentMethod - The payment gateway for the subscription.
 * @param addonPaymentMethod - The payment method for the addon.
 * @returns A boolean value indicating whether the PayPal button should be shown.
 */
const checkPaypalButtonShouldBeShown = (
  isSubscription: boolean,
  subscriptionPaymentMethod: BillingDetailsT["payment_gateway"],
  addonPaymentMethod?: AddonT["payment_method"]
) => {
  if (isSubscription) {
    return (
      !subscriptionPaymentMethod ||
      subscriptionPaymentMethod.toLowerCase() === "paypal"
    );
  }

  return (
    !addonPaymentMethod || subscriptionPaymentMethod.toLowerCase() === "paypal"
  );
};

export default checkPaypalButtonShouldBeShown;
